import { createActionType, createRequestActionTypes } from '../../helpers'

export const UPDATE_PHONE_ID = createActionType('APP', 'UPDATE_PHONE_ID')
export const SWAP_LANGUAGE = createActionType('APP', 'CHANGE_LANGUAGE')
export const FETCH_USER = createRequestActionTypes('APP', 'FETCH_USER')
export const FETCH_OPTIONS = createRequestActionTypes('APP', 'FETCH_OPTIONS')
export const FETCH_CUSTOMER_LABELS = createRequestActionTypes(
  'APP',
  'FETCH_CUSTOMER_LABELS'
)
